export const SAVE_USER = 'SAVE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const API_ERROR = 'USER_API_ERROR';
export const SET_LOADING = 'SET_LOADING';
